import { useState } from "react"
import { useTranslation } from "react-i18next"

import Confirm from "@/components/Confirm/Confirm"
import LinkWithIcon from "@/components/LinkWithIcon/LinkWithIcon"
import { Cell, Row } from "@/components/Table/Table"
import IconOption from "@/components/TableOptions/IconOption"
import { MODALS } from "@/constants/modals"
import { useRemoveProjectMutation } from "@/queries/mutations/projectMutations"
import type { StudentProject } from "@/types/projectTypes"
import { deleteIcon, editIcon, linkIcon, videoIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"

export default function ProjectsItem({
  ele,
  from,
}: {
  ele: StudentProject
  from: number
}) {
  const [removeOpen, setRemoveOpen] = useState(false)

  const { editModalState } = useStore((state) => state)

  const removeProjectMutation = useRemoveProjectMutation()

  const { t } = useTranslation()

  return (
    <Row key={ele.id} className={"fw-medium"}>
      <Cell>{`${from}`}</Cell>
      <Cell>{ele?.title}</Cell>
      <Cell>{ele?.description}</Cell>
      <Cell>
        <LinkWithIcon
          icon={linkIcon}
          href={ele?.link}
          target={"_blank"}
          tooltip={"Link"}
        />
      </Cell>
      <Cell>
        <LinkWithIcon
          tooltip={t("projectsPage.table.videoTooltip")}
          icon={videoIcon}
          onClick={() =>
            editModalState(MODALS.lecture.video, { value: ele?.video_link })
          }
        />
      </Cell>
      <Cell>{ele?.comment}</Cell>

      <Cell>
        <div className="d-flex gap-3 ">
          <IconOption
            icon={deleteIcon}
            deleteMod
            onClick={() => setRemoveOpen(true)}
            tooltip={t("buttons.delete")}
          />
          <IconOption
            icon={editIcon}
            onClick={() => editModalState(MODALS.projects.edit, ele)}
            tooltip={t("buttons.edit")}
          />
        </div>
      </Cell>
      <Confirm
        isOpen={removeOpen}
        setIsOpen={setRemoveOpen}
        type="delete"
        title={t("projectsPage.delete")}
        confirmFunc={() =>
          removeProjectMutation.mutate(ele, {
            onSuccess: () => setRemoveOpen(false),
          })
        }
        loading={removeProjectMutation.isPending}
      />
    </Row>
  )
}
